__turbopack_context__.v({
  "col": "Gutters-module__jXSUna__col",
  "gutter-desktop-12": "Gutters-module__jXSUna__gutter-desktop-12",
  "gutter-desktop-16": "Gutters-module__jXSUna__gutter-desktop-16",
  "gutter-desktop-20": "Gutters-module__jXSUna__gutter-desktop-20",
  "gutter-desktop-8": "Gutters-module__jXSUna__gutter-desktop-8",
  "gutter-desktop-l-12": "Gutters-module__jXSUna__gutter-desktop-l-12",
  "gutter-desktop-l-16": "Gutters-module__jXSUna__gutter-desktop-l-16",
  "gutter-desktop-l-20": "Gutters-module__jXSUna__gutter-desktop-l-20",
  "gutter-desktop-l-8": "Gutters-module__jXSUna__gutter-desktop-l-8",
  "gutter-desktop-m-12": "Gutters-module__jXSUna__gutter-desktop-m-12",
  "gutter-desktop-m-16": "Gutters-module__jXSUna__gutter-desktop-m-16",
  "gutter-desktop-m-20": "Gutters-module__jXSUna__gutter-desktop-m-20",
  "gutter-desktop-m-8": "Gutters-module__jXSUna__gutter-desktop-m-8",
  "gutter-desktop-s-12": "Gutters-module__jXSUna__gutter-desktop-s-12",
  "gutter-desktop-s-16": "Gutters-module__jXSUna__gutter-desktop-s-16",
  "gutter-desktop-s-20": "Gutters-module__jXSUna__gutter-desktop-s-20",
  "gutter-desktop-s-8": "Gutters-module__jXSUna__gutter-desktop-s-8",
  "gutter-mobile-12": "Gutters-module__jXSUna__gutter-mobile-12",
  "gutter-mobile-16": "Gutters-module__jXSUna__gutter-mobile-16",
  "gutter-mobile-20": "Gutters-module__jXSUna__gutter-mobile-20",
  "gutter-mobile-8": "Gutters-module__jXSUna__gutter-mobile-8",
  "gutter-tablet-12": "Gutters-module__jXSUna__gutter-tablet-12",
  "gutter-tablet-16": "Gutters-module__jXSUna__gutter-tablet-16",
  "gutter-tablet-20": "Gutters-module__jXSUna__gutter-tablet-20",
  "gutter-tablet-8": "Gutters-module__jXSUna__gutter-tablet-8",
  "gutter-tablet-l-12": "Gutters-module__jXSUna__gutter-tablet-l-12",
  "gutter-tablet-l-16": "Gutters-module__jXSUna__gutter-tablet-l-16",
  "gutter-tablet-l-20": "Gutters-module__jXSUna__gutter-tablet-l-20",
  "gutter-tablet-l-8": "Gutters-module__jXSUna__gutter-tablet-l-8",
  "gutter-tablet-s-12": "Gutters-module__jXSUna__gutter-tablet-s-12",
  "gutter-tablet-s-16": "Gutters-module__jXSUna__gutter-tablet-s-16",
  "gutter-tablet-s-20": "Gutters-module__jXSUna__gutter-tablet-s-20",
  "gutter-tablet-s-8": "Gutters-module__jXSUna__gutter-tablet-s-8",
  "row": "Gutters-module__jXSUna__row",
});
